const extraMap = {
    ß: 'ss',
    ø: 'o',
    đ: 'd'
    // add more special cases if needed
}

export function normalize(str: string): string {
    if (!str) return str
    return str
        .replace(/[ßøđ]/g, (char: string) => extraMap[char] || char)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
}
